import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { DataBlocks, Link } from 'components';
import styles from './styles.pcss';

const ARIA_LABEL_BY_MESSAGE_TYPE = {
  information: 'Внимание',
  critical: 'Ошибка',
};

const cx = classNames.bind(styles);

/** Отображение пункта меню "Персональные данные"
 * - Если есть infoPanel - отображаем;
 * - Из infoPanel берем текст для плашки (infoPanel.text) и ее цвет (infoPanel.type);
 */

const PersonalDataStatus = ({ infoPanel }) => {
  const colorPlateInEsiaUpdate = infoPanel?.type === 'information' ? 'attention' : infoPanel?.type;

  return (
    <>
      {infoPanel && (
        <DataBlocks.Block
          className={colorPlateInEsiaUpdate}
          ariaLabel={ARIA_LABEL_BY_MESSAGE_TYPE[infoPanel?.type]}
        >
          <div className={cx('content')}>
            <span dangerouslySetInnerHTML={{ __html: infoPanel?.text }} />
            {infoPanel.button && (
              <Link href={infoPanel.button.url}>
                {infoPanel.button.title}
              </Link>
            )}
          </div>
        </DataBlocks.Block>
      )}
    </>
  );
};

PersonalDataStatus.propTypes = {
  infoPanel: PropTypes.shape({
    type: PropTypes.string,
    text: PropTypes.string,
    button: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    ...state.application.settings.personalData,
  };
}

export default connect(mapStateToProps)(PersonalDataStatus);
